import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            探索视频分类
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            五大精选分类，从日本名所到中国胜景，从延时摄影到实用攻略，应有尽有
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="mt-3 text-sm font-medium text-foreground-950 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                {cat.count}个视频
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}